import { notification } from 'antd';

// Вход логин
// export const hostDomain = 'http://127.0.0.1';
// const hostPort = ':8001/';
export const hostDomain = process.env.REACT_APP_API_URL;
const hostPort = ':' + process.env.REACT_APP_API_URL_PORT + '/';
// const hostPort = ':4444/';
// const hostPort = ':9999/';
// export const hostDomain = 'https://194.61.0.136';
// const hostPort = ':86/';

if (!hostDomain || !hostPort) {
  throw new Error('Ошибка env');
}

export const hostURL = hostDomain + hostPort;

export const getLogin = (email: any, password: any) => {
  return fetch(hostURL + 'api/auth/login', {
    headers: {
      'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      Authorization: 'bearer',
    },
    method: 'POST',
    body: new URLSearchParams({
      email: email,
      password: password,
    }),
  })
    .then((res) => res.json())
    .then((res) => {
      if (res.error) {
      } else {
        if (res.role == 67270) {
          res.error = 'Не хватает прав';
        } else {
          localStorage.id = res.id;
          localStorage.access_token = res.access_token;
          localStorage.role = res.role;
          //localStorage.newsNotification = 0;
        }
      }
      return res;
    });
};

//Регистрация
export const getRegistration = (email: any, password: any, name: any) => {
  return fetch(hostURL + 'api/auth/registration', {
    headers: {
      'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      Authorization: 'bearer',
    },
    method: 'POST',
    body: new URLSearchParams({
      email: email,
      password: password,
      name: name,
    }),
  });
};

// Обновления токена
export const getRefreshTokin = () => {
  return fetch(hostURL + 'api/auth/refresh', {
    headers: {
      Authorization: 'bearer ' + localStorage.access_token,
    },
    method: 'POST',
  });
};

// получения банков для сотрудников
export const getBankApi = () => {
  return fetch(hostURL + 'api/auth/banks', {
    headers: {
      'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      Authorization: 'bearer ' + localStorage.access_token,
      Accept: 'application/json',
    },
    method: 'GET',
  });
};

// выход убийство токена

export const getLogautApi = () => {
  return fetch(hostURL + 'api/auth/logout', {
    headers: {
      Authorization: 'bearer' + localStorage.access_token,
    },
    method: 'POST',
  });
};

// все новости
export const allNews = () => {
  return fetch(hostURL + 'api/auth/news', {
    headers: {
      'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      Authorization: 'bearer ' + localStorage.access_token,
      Accept: 'application/json',
    },
    method: 'GET',
  });
};

export const firstNewsApi = () => {
  return fetch(hostURL + 'api/auth/news/lastNews', {
    headers: {
      'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      Authorization: 'bearer ' + localStorage.access_token,
      Accept: 'application/json',
    },
    method: 'GET',
  });
};

export const sendFilter = (filterup: any) => {
  console.log('filterup', filterup);
  let queryString = Object.keys(filterup)
    .map((key) => {
      let quary_param: any = '';
      if (Array.isArray(filterup[key])) {
        filterup[key].forEach((element: any) => {
          quary_param = quary_param + key + '[]=' + element + '&';
        });
      } else {
        if (filterup[key] != null) {
          quary_param = key + '=' + filterup[key] + '&';
        }
      }
      return quary_param;
    })
    .join('');
  queryString = queryString.slice(0, -1);
  console.log('daw', queryString);

  return fetch(hostURL + 'api/auth/banks/filter/query?' + queryString, {
    headers: {
      'Content-type': 'application/json',
      Authorization: 'bearer' + localStorage.access_token,
    },
    // body: JSON.stringify(filterup),
  })
    .then((res: any) => res.json())
    .then((res) => {
      if (res.message) {
      } else {
        return res;
      }
    });
};

export const keys = [
  //3 стобец для вывода фильтров
  //a-z = сортировка
  //t-f = true false
  //int = число
  //date = дата

  ['Название банка', 'title', 'a-z'],
  ['Возврат аванса', 'avance_return', 't-f'],
  ['В валюте', 'exchange', 't-f'],
  ['Лимит на клиента', 'limit_client', 'int'],
  ['Лимит БГ', 'limit_bg', 'int'],
  ['Сроки исполнения', 'limit_month', 'int'],
  ['Сроки создания', 'exec_deadline', 'int'],
  ['Сроки ГО ', 'go_deadline', 'int'],
  ['Размер БГ без опыта ', 'bg_size', 'int'],
  ['Берет ли дольку ', 'fraction_collecting', 't-f'],
  ['Берёт ли ГУП-МУП', 'gup_mup', 't-f'],
  ['Берет ли с плохой НБКИ ', 'nbki', 't-f'],
  ['Берет ли переобеспечение ', 'support', 't-f'],
  ['Берет ли оплату с третьих лиц ', 'payment', 't-f'],
  ['Берет ли без номера на закупках ', 'number', 't-f'],
  ['Берет ли компании, у которых ФЛ не резидент ', 'resident', 't-f'],
  ['Берет ли Кавказ ', 'caucasian', 't-f'],
  ['Берет ли Крым ', 'crimea', 't-f'],
  ['Завышение ', 'overstatement'],
  ['Закрытые', 'closed', 'select'],
  ['БГ больше ли НМЦК', 'nmck', 't-f'],
  ['Убытки', 'losses'],
  ['615', 'p615', 't-f'],
  ['КИК', 'kik', 't-f'],
  ['КБГ', 'kbg', 't-f'],
  ['Делает ли скидку', 'discount', 't-f'],
  ['Доставка', 'delivery', 't-f'],
  ['Берет ли под поручительство', 'guarantor', 't-f'],
  ['275 ФЗ', 'fz_275', 't-f'],
  ['505', 'p505', 't-f'],
  // ['Дата изменения ', 'changing_date', 'date'],
];

///////

export const loginAuth = (values: any) => {
  return fetch(hostURL + 'api/auth/login', {
    headers: {
      'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    method: 'POST',
    body: new URLSearchParams({
      email: values.email,
      password: values.password,
    }),
  })
    .then((res) => res.json())
    .then((commits) => {
      if (commits.access_token === undefined) {
      } else {
        localStorage.access_token = commits.access_token;
        return true;
      }
    });
};

export const logoutAuth = () => {
  fetch(hostURL + 'api/auth/logout', {
    headers: {
      'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      Accept: 'application/json',
      Authorization: 'Bearer ' + localStorage.access_token,
    },
    method: 'POST',
  }).then((res) => res.json());
};

export const getBanks = () => {
  return fetch(hostURL + 'api/auth/banks', {
    headers: {
      'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      Accept: 'application/json',
      Authorization: 'Bearer ' + localStorage.access_token,
    },
    method: 'GET',
  });
};

export const deleteBank = (id: any) => {
  return fetch(hostURL + 'api/auth/banks/' + id, {
    headers: {
      'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      Accept: 'application/json',
      Authorization: 'Bearer ' + localStorage.access_token,
    },
    method: 'DELETE',
  });
};

export const updateBank = (payload: any, id: any) => {
  return fetch(hostURL + 'api/auth/banks/' + id, {
    headers: {
      'Content-type': 'application/json;charset=utf-8',
      Accept: 'application/json',
      Authorization: 'Bearer ' + localStorage.access_token,
    },
    body: JSON.stringify(payload),
    method: 'PUT',
  });
};

export const filterBanks = (sendFilter: any) => {
  return fetch(hostURL + 'api/auth/banks/filter', {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: 'Bearer ' + localStorage.access_token,
    },
    body: JSON.stringify(sendFilter),
    method: 'GET',
  })
    .then((res) => res.json())
    .then((res) => {
      if (res.message === 'Unauthenticated.') {
        //console.log('Trying to refresh...');

        return 'Trying to refresh...';
      } else {
        return res;
      }
    });
};

export const changeBankVisible = (id: any, payload: any) => {
  return fetch(hostURL + 'api/auth/banks/visible/' + id, {
    headers: {
      'Content-type': 'application/json',

      Authorization: 'Bearer ' + localStorage.access_token,
    },
    body: JSON.stringify(payload),
    method: 'PUT',
  })
    .then((res) => res.json())
    .then((res) => {
      return res;
    });
};
export const bankConstruct = () => {
  return fetch(hostURL + 'api/auth/banks/build', {
    headers: {
      'Content-type': 'application/json',

      Authorization: 'Bearer ' + localStorage.access_token,
    },
    method: 'GET',
  })
    .then((res) => res.json())
    .then((res) => {
      return res;
    });
};

export const createBank = (payload: any) => {
  return fetch(hostURL + 'api/auth/banks', {
    headers: {
      'Content-type': 'application/json',
      Authorization: 'Bearer ' + localStorage.access_token,
    },
    body: JSON.stringify(payload),
    method: 'POST',
  });
};

export const addNewNews = (payload: any) => {
  return fetch(hostURL + 'api/auth/news/addNews', {
    headers: {
      'Content-type': 'application/json',
      Authorization: 'Bearer ' + localStorage.access_token,
    },
    body: JSON.stringify(payload),
    method: 'POST',
  });
};

export const API = {
  // запросы ядра
  registrationLink: hostURL + 'api/auth/registration',

  // функции ядра
  regPostFun: function (email: any, password: any, name: any) {
    return fetch(hostURL + 'api/auth/registration', {
      headers: {
        'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
        Authorization: 'bearer',
      },
      method: 'POST',
      body: new URLSearchParams({
        email: email,
        password: password,
        name: name,
      }),
    });
  },
};

export const changeUsersRole = (idUser: any, roleUser: any) => {
  return fetch(hostURL + 'api/auth/users', {
    headers: {
      'Content-type': 'application/json',
      Accept: 'application/json',
      Authorization: 'Bearer ' + localStorage.access_token,
    },
    body: JSON.stringify({
      id: idUser,
      role: roleUser,
    }),
    method: 'POST',
  }).then((res) => res.json());
};

export const deleteUser = (id: any) => {
  return fetch(hostURL + 'api/auth/users/' + id, {
    headers: {
      'Content-type': 'application/json',
      Accept: 'application/json',
      Authorization: 'Bearer ' + localStorage.access_token,
    },

    method: 'DELETE',
  }).then((res) => res.json());
};

export const getUsers = () => {
  return fetch(hostURL + 'api/auth/users', {
    headers: {
      'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      Accept: 'application/json',
      Authorization: 'Bearer ' + localStorage.access_token,
    },
    method: 'GET',
  }).then((res) => res.json());
};

export const getSessions = () => {
  return fetch(hostURL + 'api/auth/chats/groupForUser', {
    headers: {
      'Content-type': 'application/json',
      Accept: 'application/json',
      Authorization: 'Bearer ' + localStorage.access_token,
    },

    method: 'GET',
  }).then((res) => res.json());
};

export const getChat = (id: any) => {
  return fetch(hostURL + 'api/auth/chats/message_group/' + id, {
    headers: {
      'Content-type': 'application/json',
      Accept: 'application/json',
      Authorization: 'Bearer ' + localStorage.access_token,
    },

    method: 'GET',
  }).then((res) => res.json());
};

export const getSessionPersonal = () => {
  return fetch(hostURL + 'api/auth/chats/message', {
    headers: {
      'Content-type': 'application/json',
      Accept: 'application/json',
      Authorization: 'Bearer ' + localStorage.access_token,
    },

    method: 'GET',
  }).then((res) => res.json());
};

export const sendMessage = (id: any, payload: any) => {
  return fetch(hostURL + 'api/auth/chats/message_group/' + id, {
    headers: {
      'Content-type': 'application/json',
      Accept: 'application/json',
      Authorization: 'Bearer ' + localStorage.access_token,
    },
    body: JSON.stringify(payload),
    method: 'POST',
  }).then((res) => res.json());
};

export const sendMessagePersonal = (payload: any) => {
  return fetch(hostURL + 'api/auth/chats/message/', {
    headers: {
      'Content-type': 'application/json',
      Accept: 'application/json',
      Authorization: 'Bearer ' + localStorage.access_token,
    },
    body: JSON.stringify(payload),
    method: 'POST',
  }).then((res) => {
    if (res.ok) return res.json();
    else throw new Error('Something went wrong');
  });
};

export const createChat = (id: any) => {
  return fetch(hostURL + 'api/auth/chats/create', {
    headers: {
      'Content-type': 'application/json',
      Accept: 'application/json',
      Authorization: 'Bearer ' + localStorage.access_token,
    },
    body: JSON.stringify({ user_id: id }),
    method: 'POST',
  }).then((res) => res.json());
};

export const createGroupChat = (payload: any) => {
  return fetch(hostURL + 'api/auth/chats/group', {
    headers: {
      'Content-type': 'application/json',
      Accept: 'application/json',
      Authorization: 'Bearer ' + localStorage.access_token,
    },
    body: JSON.stringify(payload),
    method: 'POST',
  }).then((res) => res.json());
};
export const UpdateGroupChat = (payload: any) => {
  return fetch(hostURL + 'api/auth/chats/group', {
    headers: {
      'Content-type': 'application/json',
      Accept: 'application/json',
      Authorization: 'Bearer ' + localStorage.access_token,
    },
    body: JSON.stringify(payload),
    method: 'PUT',
  }).then((res) => res.json());
};

export const getUsersInGroup = (session_id: any) => {
  return fetch(hostURL + 'api/auth/chats/group/' + session_id, {
    headers: {
      'Content-type': 'application/json',
      Accept: 'application/json',
      Authorization: 'Bearer ' + localStorage.access_token,
    },
    method: 'GET',
  }).then((res) => res.json());
};

export const getChatPersonal = (id: any) => {
  return fetch(hostURL + 'api/auth/chats/message/' + id, {
    headers: {
      'Content-type': 'application/json',
      Accept: 'application/json',
      Authorization: 'Bearer ' + localStorage.access_token,
    },

    method: 'GET',
  }).then((res) => res.json());
};

export const getMessagesById = (link: any) => {
  return fetch(link, {
    headers: {
      'Content-type': 'application/json',
      Accept: 'application/json',
      Authorization: 'Bearer ' + localStorage.access_token,
    },

    method: 'GET',
  }).then((res) => res.json());
};
export const ReadChatMessages = (payload: any) => {
  return fetch(hostURL + 'api/auth/chats/read', {
    headers: {
      'Content-type': 'application/json',
      Accept: 'application/json',
      Authorization: 'Bearer ' + localStorage.access_token,
    },
    body: JSON.stringify(payload),
    method: 'POST',
  }).then((res) => res.json());
};

export const getUsersForChat = () => {
  return fetch(hostURL + 'api/auth/users/all', {
    headers: {
      'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      Authorization: 'bearer ' + localStorage.access_token,
      Accept: 'application/json',
    },
    method: 'GET',
  }).then((response) => response.json());
};
export const getResult = () => {
  return fetch(hostURL + 'api/auth/statistics/addResult', {
    headers: {
      'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      Authorization: 'bearer ' + localStorage.access_token,
      Accept: 'application/json',
    },
    method: 'GET',
  }).then((response) => response.json());
};

export const addResult = (payload: any) => {
  return fetch(hostURL + 'api/auth/statistics/addResult', {
    headers: {
      'Content-type': 'application/json;charset=utf-8',
      Authorization: 'bearer ' + localStorage.access_token,
      Accept: 'application/json',
    },
    body: JSON.stringify(payload),
    method: 'POST',
  });
  // .then((response) => response.json());
};

export const addPlan = (tstings: any) => {
  return fetch(hostURL + 'api/auth/statistics/addPlan', {
    headers: {
      Authorization: 'bearer ' + localStorage.access_token,
      Accept: 'application/json',
      'Content-type': 'application/json;charset=utf-8',
    },
    method: 'POST',
    // body: new URLSearchParams({ tstings }),
    body: JSON.stringify(tstings),
  }).then((response) => response.json());
};

export const getPlan = () => {
  return fetch(hostURL + 'api/auth/statistics/addPlan', {
    headers: {
      'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      Authorization: 'bearer ' + localStorage.access_token,
      Accept: 'application/json',
    },
    method: 'GET',
  }).then((response) => response.json());
};

export const forgotPassword = (values: any) => {
  return fetch(hostURL + 'api/auth/forgot-password', {
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json;charset=utf-8',
    },
    method: 'POST',
    // body: new URLSearchParams({ tstings }),
    body: JSON.stringify(values),
  }).then((response) => response.json());
};

export const testRefreshTokin = () => {
  return fetch(hostURL + 'api/auth/refresh', {
    headers: {
      Authorization: 'bearer ' + localStorage.access_token,
    },
    method: 'POST',
  })
    .then((res) => res.json())
    .then((token) => {
      localStorage.access_token = token.access_token;
    })
    .catch(() => {
      localStorage.clear();
      window.location.reload();
    });
};
const checkError = (res: any) => {
  switch (res.status) {
    case 401:
      return getRefreshTokin();
      break;
    case 500:
      notification.error({ message: 'Что-то пошло не так!' });
      break;
    default:
      break;
  }
};

const firstThen = (res: any) => {
  if (res.ok) {
    return res.json();
  } else {
    return checkError(res)?.then((answer) => {
      if (answer.ok) {
        return answer.json().then((token) => {
          localStorage.access_token = token.access_token;
          return token;
        });
      } else {
        localStorage.clear();
        window.location.reload();
        throw 'Проблемы с сервером';
      }
    });
  }
};
export const getHlsStreamUrl = async (videoPath: string) => {
  try {
    const response = await fetch(`${hostURL}api/auth/hr/theme/video-stream?path=${videoPath}`, {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    // Возвращаем URL манифеста
    return response.url; // Это будет URL к HLS манифесту
  } catch (error) {
    console.error('Error fetching HLS stream URL:', error);
    throw error;
  }
};
